// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1h18B","controls":"styles_controls__3e4CX","charLimit":"styles_charLimit__1xKqm","input":"styles_input__1-aFY","send":"styles_send__x_8DG"};